/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Creates an instance ID generator.
 *
 * @returns A function that returns a unique sequential ID on each call.
 */
const setupGetInstanceId = () => {
  let instanceId = 0;
  return () => ++instanceId;
};

exports.setupGetInstanceId = setupGetInstanceId;
